<template>
  <div class="flex align-items-center justify-content-center min-h-screen min-w-screen">
    <div class="surface-card border-round-xl p-6 text-center shadow-2">
      <h1 class="text-2xl mt-0 mb-2">
        Connect Vocab
      </h1>
      <p class="text-600 mb-4">
        Continue with Google to sign in to the Chrome extension.
      </p>
      <div
        ref="googleButton"
        class="google-button"
      />
      <Message
        v-if="error"
        severity="error"
        :closable="false"
        class="mt-4"
      >
        {{ error }}
      </Message>
    </div>
  </div>
</template>

<script>
import Message from 'primevue/message'
import { userService } from '../service'
import { renderGoogleButton } from '../service/google-identity.service'

const validState = /^[A-Za-z0-9_-]{43}$/

export default {
  components: { Message },
  data () {
    return { error: '' }
  },
  async mounted () {
    const state = String(this.$route.query.state || '')
    if (!validState.test(state)) {
      this.error = 'This extension sign-in request is invalid.'
      return
    }

    try {
      const response = await userService.getGoogleConfig('extension')
      const config = response.data
      await renderGoogleButton({
        element: this.$refs.googleButton,
        clientId: config.client_id,
        callback: ({ credential }) => this.completeSignIn(config.redirect_uri, state, credential)
      })
    } catch (error) {
      this.error = error.message || 'Unable to start Google Sign-In.'
    }
  },
  methods: {
    completeSignIn (redirectURI, state, credential) {
      if (!credential) {
        this.error = 'Google did not return a sign-in credential.'
        return
      }
      const target = new URL(redirectURI)
      const fragment = new URLSearchParams({ credential, state })
      target.hash = fragment.toString()
      window.location.assign(target.toString())
    }
  }
}
</script>

<style scoped>
.google-button {
  min-height: 44px;
  display: flex;
  justify-content: center;
}
</style>
